/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2021, Zumper
 */

export const generateUid = () => Math.random().toString(36).substr(2, 10)
